import { STATEMENT_STATUSES } from "@/app/projects/constants";
import isStatus from "./is-status";

export const isStatementProcessing = (statement) =>
  isStatementStatus(statement, "extracting", "categorizing");

export const isStatementStatus = (statement, ...expectations) =>
  isStatus(STATEMENT_STATUSES, statement, "status", ...expectations);
